import { render, staticRenderFns } from "./AddOtherSupplier.vue?vue&type=template&id=3ab80da7&scoped=true"
import script from "./AddOtherSupplier.vue?vue&type=script&lang=js"
export * from "./AddOtherSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddOtherSupplier.vue?vue&type=style&index=0&id=3ab80da7&prod&lang=scss&scoped=true"
import style1 from "./AddOtherSupplier.vue?vue&type=style&index=1&id=3ab80da7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab80da7",
  null
  
)

export default component.exports